import { useState } from "react";
import { getTrackBackground, Range } from "react-range";
import { separate } from "../PaymentHistory";
import { MdOutlineKeyboardArrowDown, MdOutlineKeyboardArrowUp } from "react-icons/md";
import axios from "axios";
import { subject_price_changer } from "../../api/api";
import { toast } from "react-toastify";




const PriceRangeButton = ({ data, selcetedItem, user_id }) => {

    const item = selcetedItem !== null ? data.filter(f => f.id === selcetedItem) : [data[0]]
    const maxAllowedPublisherShare = item[0]?.maxAllowedPublisherShare
    const price = item[0]?.branchLinks[0]?.minPrice

    const customPrice = maxAllowedPublisherShare < item[0]?.customPublisherShare ? maxAllowedPublisherShare : item[0]?.customPublisherShare

    const post_id = item[0]?.id
    const MIN = price
    const STEP = 1000

    const [priceRange, setPriceRange] = useState([customPrice ? customPrice : price ? price : 0])
    const [openBox, setOpenBox] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    const handleClickPriceChanger = () => {
        setOpenBox(!openBox)
    }

    const handleSubmitPriceChanger = async (e) => {
        e.preventDefault()

        try {
            setIsLoading(true)
            const body = {
                customPublisherShare: priceRange[0],
                publisherUserId: user_id
            }
            await axios.put(subject_price_changer(post_id), body)
            toast.success('قیمت شما با موفقیت ثبت شد')

        } catch (error) {
            console.log(error);

        } finally {
            setIsLoading(false)
        }

    }

    if (priceRange > 0 && maxAllowedPublisherShare)
        return (<>

            {maxAllowedPublisherShare < item[0]?.customPublisherShare && <div className="errorCustomPrice">قیمت تایین شده شما ({separate(item[0]?.customPublisherShare)}) بیش از سقف قیمتی ({separate(maxAllowedPublisherShare)}) می‌باشد.</div>}

            <div className="versionLinks">
                <span>قیمت :</span>
                <button type="button" className="priceChanger" onClick={handleClickPriceChanger}>
                    <p>{separate(customPrice ? customPrice : price)} <small>ریال</small></p>
                    <div className='svgicon'>{openBox ? <MdOutlineKeyboardArrowUp /> : <MdOutlineKeyboardArrowDown />}</div>
                </button>
            </div>

            {openBox && <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    flexWrap: "wrap",
                    direction: 'ltr',
                    width: '78%',
                    margin: '10px auto',
                    position: 'relative'
                }}
            >
                <Range
                    values={priceRange}
                    step={STEP}
                    min={MIN}
                    max={maxAllowedPublisherShare}
                    onChange={(values) => setPriceRange(values)}
                    // renderMark={({ props, index }) => (
                    //     <div
                    //         {...props}
                    //         key={props.key}
                    //         style={{
                    //             ...props.style,
                    //             height: "15px",
                    //             width: "2px",
                    //             backgroundColor:
                    //                 index * STEP + MIN < priceRange[0]
                    //                     ? "#5098ef"
                    //                     : "#ccc",
                    //         }}
                    //     />
                    // )}
                    renderTrack={({ props, children }) => (
                        <div
                            onMouseDown={props.onMouseDown}
                            onTouchStart={props.onTouchStart}
                            style={{
                                ...props.style,
                                height: "36px",
                                display: "flex",
                                width: "100%",
                            }}
                        >
                            <div
                                ref={props.ref}
                                style={{
                                    height: "5px",
                                    width: "100%",
                                    borderRadius: "5px",
                                    background: getTrackBackground({
                                        values: priceRange,
                                        colors: ["#f57c00", "#ccc"],
                                        min: MIN,
                                        max: maxAllowedPublisherShare,
                                    }),
                                    alignSelf: "center",
                                }}
                            >
                                {children}
                            </div>
                        </div>
                    )}
                    renderThumb={({ props, isDragged }) => (
                        <div
                            {...props}
                            key={props.key}
                            style={{
                                ...props.style,
                                height: "25px",
                                width: "25px",
                                borderRadius: "4px",
                                backgroundColor: "#FFF",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                boxShadow: "0px 2px 6px #00000029",
                            }}
                        >
                            <div
                                style={{
                                    height: "16px",
                                    width: "5px",
                                    backgroundColor: isDragged ? "#f57c00" : "#d9d9d9",
                                }}
                            />
                        </div>
                    )}
                />
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 5, width: '100%' }}>
                    <small style={{ marginLeft: '-18px', fontWeight: 300, letterSpacing: '1px' }}>{separate(MIN)}</small>
                    <output style={{ letterSpacing: '1px', direction: 'rtl', fontSize: 14 }}>{separate(priceRange[0])} <small>ریال</small></output>
                    <small style={{ marginRight: '-18px', fontWeight: 300, letterSpacing: '1px' }}> {separate(maxAllowedPublisherShare)}</small>
                </div>

                {(priceRange[0] !== price && priceRange[0] !== customPrice) && <form style={{ marginTop: 20, direction: 'rtl' }} onSubmit={handleSubmitPriceChanger}>
                    <input style={{ fontSize: 15, fontWeight: 300, padding: '5px 10px' }} type="submit" value={isLoading ? 'لطفا صبر کنید...' : 'ثبت تغییر قیمت'} disabled={isLoading} />
                </form>}

            </div>}
        </>);
}

export default PriceRangeButton;